"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeRetrocessionPriceFromFee = computeRetrocessionPriceFromFee;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const big_js_1 = __importDefault(require("big.js"));
function computeRetrocessionPriceFromFee(selectedFee, quantity = 1, weightInGrams = 0) {
    if (selectedFee.unit === module_logistic_interfaces_1.RetroCedingUnit.Euro)
        return selectedFee.value;
    if (selectedFee.unit === module_logistic_interfaces_1.RetroCedingUnit.EuroPerArticle)
        return (0, big_js_1.default)(selectedFee.value).times(quantity).toString();
    return (0, big_js_1.default)(selectedFee.value).times(weightInGrams).div(1000).toString();
}
